<template>
    <div class="action-notice-inform-document">
        <div class="title f-bold" v-html="$translate('ACTION_NOTICE_INFORM_DOCUMENT_TITLE')" />
        <div class="body">
            <div v-html="body" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'ActionNoticeInformDocument',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        chatUser() {
            if (!this.chat) return

            return (this.chat || {}).user
        },
        body() {
            const body = this.$translate('ACTION_NOTICE_INFORM_DOCUMENT_BODY')
            return body
        },
    },
}
</script>
